import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import CustomButton from "../customButton";

const ConfirmationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} sx={{
      "& .MuiDialog-paper": {
        borderRadius: "20px",
      },
    }}  >
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold",
        background: "linear-gradient(90deg, #225B27, #053608)",
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px",
        color: "#fff",
      }}>
        Confirmation !
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            color: "primary.main",
            textAlign: "center",
            mt: 1,
            mb: 2,
            fontWeight: 500,
          }}
        >
          Are you sure you want to delete this?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <CustomButton
          btnLabel="Cancel"
          variant="outlined"
          btnBgColor="transparent"
          btnTextColor="#225B27"
          borderColor="#225B27"
          width={130}
          isBorder={"1px solid"}
          borderRadius={3}
          handlePressBtn={onClose}
        />
        <CustomButton
          borderRadius={3}
          btnLabel="Yes"
          width={130}
          variant={"webbutton"}
          handlePressBtn={onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
